import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";

export namespace LegalsValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            file: baseVals.file(),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
        }),
    );
}
